import ApiRoles from '@/api/apiErp/apiErpRoles';

export default {
  async getDestinationRoles({ commit }, { destinationId, user }) {
    try {
      const destinationRolesResponse = await ApiRoles.getRolesByDestination(destinationId, user);
      if (destinationRolesResponse.status === 200) {
        commit('setDestinationRoles', destinationRolesResponse.data.values);
      }
    } catch (e) {
      throw e;
    }
  },
  setAffectableForCurrentObject({ commit }, { response }) {
    if (response.data && response.data.values) {
      commit('setAffectableForCurrentObject', response.Data.values);
    }
    commit('setAffectableForCurrentObject', []);
  },
};
